import Immutable from 'immutable';
import { createSelector } from 'reselect';

const paymentTransactionSelector = (state) => state.PaymentTransaction;

export const currentSubscriptionPurchaseSelector = createSelector(
  paymentTransactionSelector,
  (paymentTransaction) => {
    const purchaseItem = paymentTransaction
      .getIn(['paymentTransaction', 'purchaseItems'], Immutable.List())
      .first();

    if (purchaseItem && purchaseItem.get('type') === 'subscription_plan') {
      return purchaseItem;
    }
    return null;
  }
);

export const selectPaymentMethod = createSelector(
  paymentTransactionSelector,
  (paymentTransaction) => paymentTransaction.get('paymentMethod')
);

export const selectPaymentMethods = createSelector(
  paymentTransactionSelector,
  (paymentTransaction) => paymentTransaction.get('paymentMethods')
);

export const selectIsTrialSubscriptionPurchase = createSelector(
  paymentTransactionSelector,
  (paymentTransaction) => {
    const purchaseItem = paymentTransaction
      .getIn(['paymentTransaction', 'purchaseItems'], Immutable.List())
      .first();

    return purchaseItem && purchaseItem.getIn(['data', 'isTrial']);
  }
);
